<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ client.firma ? client.firma.NAZWA_PELNA : client.nazwa_pelna }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.address', client.id)">Adresy firmy</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowy adres firmy
    </h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full xl:w-1/2">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.siedziby" :error="form.errors.siedziby" :checked="form.siedziby" label="Adres siedziby" />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.dzialalnosci" :error="form.errors.dzialalnosci" :checked="form.dzialalnosci" label="Adres działalności" />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.korespondencji" :error="form.errors.korespondencji" :checked="form.korespondencji" label="Adres dla korespondencji" />
            <div class="w-1/2 form-error">
              <span v-if="form.errors.typ_adresu">{{form.errors.typ_adresu}}</span>
            </div>
            <text-input v-model="form.data_od" :error="form.errors.data_od" class="pr-6 pb-8 w-full lg:w-1/2" label="Data obowiązywania" :isLoading="isLoading" type="date" />
            <div class=" w-1/2"></div>

            <text-input v-model="form.kraj_symbol" :error="form.errors.kraj_symbol" class="pr-6 pb-8 w-full lg:w-1/2" label="Symbol kraju" :isLoading="isLoading" />
            <text-input v-model="form.wojewodztwo" :error="form.errors.wojewodztwo" class="pr-6 pb-8 w-full lg:w-1/2" label="Województwo" :isLoading="isLoading" />
            <text-input v-model="form.powiat" :error="form.errors.powiat" class="pr-6 pb-8 w-full lg:w-1/2" label="Powiat" :isLoading="isLoading" />
            <text-input v-model="form.gmina" :error="form.errors.gmina" class="pr-6 pb-8 w-full lg:w-1/2" label="Gmina" :isLoading="isLoading" />
             
            <text-input v-model="form.kod_pocztowy" :error="form.errors.kod_pocztowy" class="pr-6 pb-8 w-full lg:w-1/2" label="Kod pocztowy" :isLoading="isLoading" />
            <text-input v-model="form.miejscowosc" :error="form.errors.miejscowosc" class="pr-6 pb-8 w-full lg:w-1/2" label="Miejscowość" :isLoading="isLoading" />
            <text-input v-model="form.ulica" :error="form.errors.ulica" class="pr-6 pb-8 w-1/2" label="Ulica" :isLoading="isLoading" />
            <text-input v-model="form.nr_domu" :error="form.errors.nr_domu" class="pr-6 pb-8 w-1/4" label="Nr domu" :isLoading="isLoading" />
            <text-input v-model="form.nr_lokalu" :error="form.errors.nr_lokalu" class="pr-6 pb-8 w-1/4" label="Nr lokalu" :isLoading="isLoading" />

            <multiselect-input v-model="form.urzad" :error="form.errors.urzad" class="pr-6 pb-8 w-full" :options="urzedy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Urząd Skarbowy" :searchable="true" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Stwórz adres</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'
import axios from 'axios'

export default {
  metaInfo() {
    return { title: 'Nowy adres firmy' }
  },
  components: {
    Icon,
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    MultiselectInput
  },
  layout: Layout,
  props: {
    urzedy: Array,
    client: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        ulica: null,
        kod_pocztowy: null,
        miejscowosc: null,
        wojewodztwo: null,
        powiat: null,
        kraj_symbol: 'PL',
        nr_domu: '',
        nr_lokalu: '',
        gmina: '',
        urzad: this.client.firma.adresy[0].urzad ? {'id': this.client.firma.adresy[0].urzad.ID_URZEDU, 'name': this.client.firma.adresy[0].urzad.NAZWA} : {id: 35, name: 'Pierwszy Przykładowy Urząd Skarbowy'},
        siedziby: false,
        dzialalnosci: false,
        korespondencji: false,
        data_od: this.now(),
        typ_adresu: 0
      }),
      isLoading: false
    }
  },
  methods: {
    store() {
      this.form.typ_adresu = this.form.siedziby || this.form.dzialalnosci || this.form.korespondencji ? 1 : 0
      this.form.post(this.route('clients.address.store', this.client.id))
    },
    now() {
      let today = new Date()

      return today.getFullYear() +'-'+ (today.getMonth()< 9 ? ('0' +(today.getMonth() +1)) : (today.getMonth() +1)) +'-'+ (today.getDate()< 10 ? ('0' +(today.getDate())) : (today.getDate()));
    }
  }

}
</script>